<template>
    <footer>
        <div class="site-footer-top">
            <div class="container">
                <div v-if="isPwa" class="site-footer-top__registration">
                    <h2 class="site-footer-top__title" v-html="dictionary.getDiscount"></h2>
                    <div>
                        <form class="site-footer-top__input-container" @submit.prevent="sendRegistrationForm">
                            <input v-model="email" type="email" class="site-footer-top__input" :placeholder="dictionary.emailPlaceholder" />
                            <button class="site-footer-top__button">
                                {{ dictionary.wannaGetDiscount }}
                            </button>
                        </form>
                    </div>
                </div>

                <!--                <div class="site-footer-top__advantages">-->
                <!--                    <span v-for="(footerAdvantage, index) in footerAdvantages" :key="index" class="site-footer-top__link" tabindex="-1">-->
                <!--                        <img :src="footerAdvantage.imageUrl" :alt="footerAdvantage.imageUrl" class="site-footer-top__img" loading="lazy" />-->
                <!--                        <a v-if="footerAdvantage.url" :href="footerAdvantage.url" v-html="footerAdvantage.title" class="site-footer-top__text"></a>-->
                <!--                        <span v-else v-html="footerAdvantage.title" class="site-footer-top__text"></span>-->
                <!--                    </span>-->
                <!--                </div>-->
            </div>
        </div>

        <div class="site-footer-bottom">
            <div class="container">
                <!--                <div class="footer-backtop" id="footer-backtop" @click="backToTop"></div>-->
                <div class="footer-main">
                    <div>
                        <img src="/nuxt-assets/design2025/logo-white-dot.svg" class="mb-md-4" />

                        <div class="d-none d-md-block">
                            <MobileApps :dictionary="dictionary" :androidUrl="androidUrl" :iosUrl="iosUrl" />
                        </div>
                    </div>

                    <div v-for="(footerLinkSection, index) in footerLinkSections" :key="index">
                        <div class="footer-main__title">
                            {{ footerLinkSection.title }}
                        </div>
                        <a
                            v-for="(footerLink, i) in footerLinkSection.links"
                            :key="i"
                            :href="footerLink.url"
                            class="footer-main__link"
                            :class="footerLink.class ? footerLink.class : ''"
                            :target="footerLink.isOutlink ? '_blank' : null"
                            :rel="footerLink.isOutlink ? 'noopener noreferrer' : null"
                        >
                            {{ footerLink.title }}
                        </a>
                    </div>
                </div>

                <div class="footer__bottom">
                    <div v-if="Object.keys(dictionary.sukl).length > 1" class="suklDown">
                        <a
                            v-if="dictionary.sukl.footerSukl"
                            class="footer-sukl"
                            :href="dictionary.sukl.footerSukl.url"
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            <img
                                :src="dictionary.sukl.footerSukl.imagePath"
                                width="80"
                                loading="lazy"
                                :alt="dictionary.sukl.footerSukl.alt"
                            />
                        </a>
                        <a
                            v-if="dictionary.sukl.footerSukl1"
                            class="footer-sukl"
                            :href="dictionary.sukl.footerSukl1.url"
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            <img
                                :src="dictionary.sukl.footerSukl1.imagePath"
                                width="80"
                                loading="lazy"
                                :alt="dictionary.sukl.footerSukl1.alt"
                            />
                        </a>
                        <a
                            v-if="dictionary.sukl.footerUskvbl1"
                            class="footer-sukl"
                            :href="dictionary.sukl.footerUskvbl1.url"
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            <img
                                :src="dictionary.sukl.footerUskvbl1.imagePath"
                                width="80"
                                loading="lazy"
                                :alt="dictionary.sukl.footerUskvbl1.alt"
                            />
                        </a>
                        <a
                            v-if="dictionary.sukl.footerUskvbl"
                            class="footer-sukl"
                            :href="dictionary.sukl.footerUskvbl.url"
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            <img
                                :src="dictionary.sukl.footerUskvbl.imagePath"
                                width="80"
                                loading="lazy"
                                :alt="dictionary.sukl.footerUskvbl.alt"
                            />
                        </a>
                    </div>

                    <div class="d-block d-md-none">
                        <MobileApps :dictionary="dictionary" :androidUrl="androidUrl" :iosUrl="iosUrl" />
                    </div>

                    <div v-if="lang === 'sk'" class="d-flex align-items-center justify-content-center pt-3 pb-4 mx-2">
                        <img :src="`nuxt-assets/footer/superbrands-sk.png`" width="112" height="110" alt="Superbrands" loading="lazy" />
                    </div>

                    <div class="flags" :class="{ 'flags--opened': flagsOpened }">
                        <div class="flags__select" @click.prevent="flagsOpened = !flagsOpened">
                            <img :src="`/nuxt-assets/images/flags/cz.svg`" width="28" loading="lazy" />
                            {{ translationFlags[0].title }}
                        </div>
                        <div class="flags__container">
                            <a
                                v-for="translationFlag in translationFlags"
                                :key="translationFlag.id"
                                href="#"
                                :title="translationFlag.title"
                                @click="translateWeb(translationFlag.code)"
                            >
                                <img
                                    :src="`/nuxt-assets/images/flags/${translationFlag.code}.svg`"
                                    :alt="translationFlag.title"
                                    width="28"
                                    loading="lazy"
                                />
                                {{ translationFlag.title }}
                            </a>
                            <a v-for="footerFlag in footerFlags" :key="footerFlag.id" :href="footerFlag.url" target="_blank">
                                <img :src="`/nuxt-assets/images/flags/${footerFlag.code}.svg`" alt="footerFlag" width="28" loading="lazy" />
                                {{ footerFlag.title }}
                            </a>
                        </div>
                    </div>

                    <!--                    <RatingShop :dictionary="dictionary" />-->
                </div>
            </div>
        </div>

        <div class="site-footer-copy">
            <div class="site-footer-copy__container">
                <p>{{ dictionary.copyright }}</p>
                <div class="social-links">
                    <a
                        v-for="(footerSocial, index) in footerSocials"
                        :key="index"
                        :href="footerSocial.link"
                        class="hover-tdn"
                        target="_blank"
                        tabindex="-1"
                        :title="footerSocial.title"
                    >
                        <img :src="footerSocial.image" />
                    </a>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import RatingShop from './RatingShop'
import MobileApps from './MobileApps'

export default {
    components: {
        MobileApps,
        RatingShop,
    },

    props: {
        lang: {
            type: String,
            default: '',
        },
        dictionary: {
            type: Object,
            required: true,
        },
        isPwa: {
            type: Boolean,
            required: false,
            default: false,
        },
        androidUrl: {
            type: String,
            default: '',
        },
        iosUrl: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            footerAdvantages: this.dictionary.advantages,
            footerLinkSections: this.dictionary.linkSections,
            footerSocials: this.dictionary.socials,
            footerFlags: this.dictionary.flags,
            translationFlags: this.dictionary.translations.flags,
            email: '',
            flagsOpened: false,
        }
    },

    methods: {
        backToTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' })
        },

        sendRegistrationForm() {
            this.$emit('newsletterRegistrationFormSubmitted', this.email)

            this.email = ''
        },

        openRegistrationPopUp() {
            this.$emit('openRegistrationPopUp')
        },

        translateWeb(code) {
            this.$emit('translateWeb', code)
        },

        closeFlags(event) {
            const target = event.target
            if (!target.closest('.flags')) {
                this.flagsOpened = false
            }
        },
    },

    mounted() {
        document.addEventListener('click', this.closeFlags)
    },

    beforeUnmount() {
        document.removeEventListener('click', this.closeFlags)
    },
}
</script>

<style lang="scss">
.site-footer-top {
    background: #146154 url('/nuxt-assets/design2025/footer/footer-dots.png') no-repeat right bottom / contain;
    color: #333333;
    font-size: 12px;

    @media only screen and (min-width: 576px) {
        font-size: 14px;
    }

    .container {
        max-width: 1320px;
    }

    &__link {
        padding: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 10px;
    }

    &__registration {
        padding: 50px 0;

        @media (min-width: 768px) {
            display: flex;
            flex-direction: row;
            gap: 80px;
            justify-content: center;
            align-items: center;
            padding: 70px 0;
        }
    }

    &__title {
        font-family: 'scale-variable', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans',
            'Droid Sans', 'Helvetica Neue', sans-serif;
        font-variation-settings: 'wght' 600, 'wdth' 120;
        color: #fccce6;
        font-size: 25px;
        line-height: 38px;
        margin: 0 0 20px;
        max-width: 400px;

        @media (min-width: 768px) {
            margin: 0;
            font-size: 30px;
        }
    }

    &__input-container {
        background: #fff;
        border-radius: 34px;
        padding: 9px;
        display: grid;
        grid-template-columns: 1fr auto;
        align-items: center;
    }

    &__input {
        border: 2px solid #fff;
        background: #fff url('/nuxt-assets/design2025/icons/mail.svg') no-repeat 9px center / 20px 20px;
        border-radius: 34px;
        padding: 9px 9px 9px 39px;
        font-size: 16px;
        font-weight: 500;
        color: #064740;
        width: 100%;

        &::placeholder {
            color: #064740;
            opacity: 1; /* Firefox */
        }

        @media (min-width: 768px) {
            min-width: 340px;
            padding: 9px 9px 9px 54px;
            background: #fff url('/nuxt-assets/design2025/icons/mail.svg') no-repeat 16px center / 20px 20px;
        }

        &:focus-visible {
            outline: none;
            border: 2px solid #fff !important;
        }
    }

    &__button {
        background: #9ffa9d;
        border-radius: 100px;
        color: #064740;
        display: block;
        font-size: 16px;
        font-weight: 500;
        padding: 10px 15px;
        text-align: center;
        cursor: pointer;
        //width: 150px;

        &:hover {
            background: #9ffa9d;
            color: #064740;
        }

        @media (min-width: 768px) {
            padding: 10px 60px;
            //width: auto;

            &:hover {
                background: #064740;
                color: #9ffa9d;
            }
        }
    }

    &__text {
        font-weight: 500;
        font-size: 14px;
        line-height: 22px;
        color: #146154;
        text-decoration: none;
        text-align: center;

        &:hover {
            color: #146154;
        }
    }

    &__img {
        max-width: 40px;
        width: auto;
        max-height: 40px;
        height: auto;

        @media only screen and (min-width: 980px) {
            max-width: 40px;
            max-height: 40px;
        }
    }

    &__advantages {
        display: grid;

        @media only screen and (min-width: 768px) {
            grid-template-columns: 1fr 1fr 1fr;
        }
    }
}

.site-footer-bottom {
    background: #064740;
    width: 100%;
    color: #064740;

    .container {
        position: relative;
        max-width: 1320px;
    }
}

.site-footer-copy {
    background: #064740;
    color: #a1cdc0;
    font-size: 14px;

    @include screen-md {
        border-top: 1px solid #146154;
    }

    p {
        margin: 0;
    }

    &__container {
        border-top: 1px solid #146154;
        max-width: 1300px;
        display: flex;
        align-items: start;
        justify-content: space-between;
        flex-direction: column-reverse;
        flex-wrap: wrap;
        gap: 20px;
        padding: 20px 0px 50px;
        margin: 0 15px;

        @include screen-md {
            flex-direction: row;
            padding: 20px 10px;
            align-items: center;
            margin: 0 auto;
            border-top: 0;
        }
    }
}

.footer-backtop {
    opacity: 1;
    position: absolute;
    z-index: 2;
    cursor: pointer;
    bottom: 5px;
    right: calc(50% - 15px);
    width: 30px;
    height: 30px;
    display: none;
    background: url('https://www.pilulka.cz/nuxt-assets/images/icons/backtop-hover.svg') center center / contain no-repeat;

    @media (min-width: 1350px) {
        right: -30px;
        top: 3em;
        bottom: auto;
        display: inline-block;
    }
}

.flags {
    display: flex;
    gap: 10px;
    position: relative;
    width: 186px;
    font-size: 14px;

    img {
        border-radius: 100%;
        width: 16px;
        height: 16px;
    }

    &__select {
        display: grid;
        grid-template-columns: 20px 110px 8px;
        align-items: center;
        gap: 8px;
        font-size: 14px;
        color: #fff;
        border: 1px solid #fff;
        border-radius: 8px;
        cursor: pointer;
        padding: 13px 16px;

        &:after {
            height: 8px;
            width: 8px;
            content: '';
            border-top: 2px solid #fff;
            border-left: 2px solid #fff;
            border-right: 0;
            border-bottom: 0;
            transform: rotate(-135deg);
            border-radius: 1px;
        }
    }

    &__container {
        position: absolute;
        bottom: 100%;
        right: 0;
        width: 186px;
        border: 1px solid #fff;
        border-radius: 8px;
        display: none;
        background: #064740;
        padding: 8px 8px;
        gap: 3px;

        a {
            color: #fff;
            display: grid;
            grid-template-columns: 20px 110px 8px;
            padding: 8px 8px;
            gap: 8px;
            border-radius: 8px;

            &:hover {
                background: #146154;
            }
        }
    }

    &--opened {
        .flags__select:after {
            transform: rotate(45deg);
            position: relative;
            top: 4px;
        }

        .flags__container {
            display: flex;
            flex-direction: column;
        }
    }
}

.footer-social {
    display: inline-flex;
    flex-wrap: wrap;
    justify-content: center;
}

.footer-main {
    padding-top: 2em;
    display: grid;
    gap: 30px;

    @media (min-width: 768px) {
        padding-top: 4em;
        grid-template-columns: 25% 25% 25% 25%;
        gap: 2%;
    }

    &__title {
        color: #e9f8eb;
        font-size: 18px;
        font-weight: 500;
        margin-bottom: 0;
        cursor: auto !important;
        padding-top: 0;
        padding-bottom: 1em;
    }

    &__link {
        display: inherit;
        width: 100%;
        color: #a1cdc0;
        line-height: 18px;
        font-size: 14px;
        font-weight: 400;
        padding: 7px 0;
        text-decoration: none;
        transition: 150ms ease-in-out;

        &:hover {
            transition: 150ms ease-in-out;
            text-decoration: underline;
            color: #a1cdc0;
        }
    }
}

.social-links {
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 15px;
}

.suklDown {
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: start;
    flex-wrap: wrap;
    margin: 0 0 0;
}

.footer__bottom {
    display: flex;
    flex-direction: column-reverse;
    margin: 30px auto 0;
    padding-bottom: 40px;
    align-items: start;
    justify-content: space-between;
    flex-wrap: wrap;
    background: none;
    gap: 30px;

    @media (min-width: 768px) {
        flex-direction: row;
        margin: 60px auto 0;
        align-items: center;
    }
}

.android-only,
.desktop-only,
.ios-only {
    display: block !important;
}

body.isDesktop .desktop-only,
body.isAndroid .android-only,
body.isIos .ios-only {
    display: block !important;
}
</style>
